import React from "react";
import PropTypes from 'prop-types';
import { Title, Icon, Count } from "./atoms";

export const PageTitle = ({ icon, title, svg, count }) => {
  return (
    <div className="d-flex align-items-center">
      {svg &&
        <div className="mr-2">
          {svg}
        </div>
      }
      {icon &&
        <div className="mr-2">
          <Icon className={icon} />
        </div>
      }
      <Title>{title}</Title>
      {count !== undefined &&
        <Count>
          ({count})
        </Count>
      }
    </div>
  );
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  svg: PropTypes.node,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
